
import { Component, OnInit, ViewChild, EventEmitter, OnDestroy } from '@angular/core';
import {  MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import {  MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { NotificationService } from 'src/app/shared/notification.service';
import { CommonPopup } from '../common-popup/common-popup';
import { DialogDelete } from 'src/app/dialog-delete/dialog-delete.component';
import { Observable, Subscription } from 'rxjs';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import { CollectionReference } from '@angular/fire/compat/firestore';

import { TaskDetailPopup } from './task-detail-popup/task-detail-popup';
import { map } from 'rxjs/operators';
import { SystemService } from '../../services/system.service';
import { ScheculedTaskService } from 'src/app/services/scheculed-task.service';

export interface PeriodicElement {
  name: string;
  id: number;
  email: string;
  rfid: number;
  status: boolean;
  type: boolean;
  dbid: string;
}

const ELEMENT_DATA: PeriodicElement[] = [];

@Component({
  selector: 'app-scheculed-task',
  templateUrl: './scheculed-task.component.html',
  styleUrls: ['./scheculed-task.component.css']
})


export class ScheduledTaskComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['id', 'name', 'email', 'credit', 'status', 'type', 'detail', 'view', 'edit'];

  approvedDataSource = new MatTableDataSource(ELEMENT_DATA);
  // notApprovedDataSource = new MatTableDataSource(ELEMENT_DATA);
  siteId: string;
  user: User;
  categories$: Observable<{}>;
  dbPath: CollectionReference;
  @ViewChild(MatSort,{static:false}) sort: MatSort;
  siteId$: Observable<any>;

  columnSettings: ColumnSetting[] = [
    {
      columnId: 'name',
      name: 'Name',
      maxLengthOnMobile: 10
    }, {
      columnId: 'groupName',
      name: 'Group',
      maxLengthOnMobile: 10
    }, {
      columnId: 'groupKey',
      name: 'Group ID',
      maxLengthOnMobile: 10
    }, {
      columnId: 'groupCheck',
      name: 'Check',
      maxLengthOnMobile: 10
    }, {
      columnId: 'companyName',
      name: 'company',
      maxLengthOnMobile: 10
    }, {
      columnId: 'siteName',
      name: 'site',
      maxLengthOnMobile: 10
    }, {
      columnId: 'status',
      name: 'Status',
      maxLengthOnMobile: 10
    }, {
      columnId: 'color',
      name: 'Color',
      maxLengthOnMobile: 10
    }, {
      columnId: 'performAt',
      name: 'PerformAt',
      maxLengthOnMobile: 10
    }, {
      columnId: 'worker',
      name: 'type',
      maxLengthOnMobile: 10
    }, {
      columnId: 'lastPerformed',
      name: 'lastPerformed',
      maxLengthOnMobile: 10
    }]

  onDelete: EventEmitter<ActionButtonEvent>;
  onAdd: EventEmitter<ActionButtonEvent>;
  onImport: EventEmitter<ActionButtonEvent>;
  onEdit: EventEmitter<ActionButtonEvent>;

  onDeleteSubscription: Subscription;
  onAddSubscription: Subscription;
  onImportSubscription: Subscription;
  onEditSubscription: Subscription;
  dialogSub: Subscription;
  paramsSub: Subscription;
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: any; }[] = [];
  topbarActionButton: { icon: string; tooltip: string; eventEmitter: any; }[] = [];



  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    public auth: AuthService,
    public scheculedTaskService: ScheculedTaskService,
    private notifierService: NotificationService,
  ) {

    this.categories$ = this.scheculedTaskService.getCombined().pipe(map(doc => {
      return doc.map(data => {
        return {
          ...data,
          companyName: data['companyName'] ? data['companyName'] : "d",
          siteName: data['siteName'] ? data['siteName'] : "d",
        }
      })

    }))
    


    this.onDelete = new EventEmitter<ActionButtonEvent>();
    this.onAdd = new EventEmitter<ActionButtonEvent>();
    this.onImport = new EventEmitter<ActionButtonEvent>();
    this.onEdit = new EventEmitter<ActionButtonEvent>();


    this.onDeleteSubscription = this.onDelete.subscribe(event => {
      this.deleteUser(event.eventData.dbid);
    });

    this.onAddSubscription = this.onAdd.subscribe(event => {
      this.addCategory();
    });

    this.onEditSubscription = this.onEdit.subscribe(event => {
      this.showDetail(event.eventData);
    });


    this.auth.user$.subscribe(user => {
      this.user = user;
      // console.log(this.rowActionButtons.filter(b=> b.icon == 'edit').length)
      if (this.rowActionButtons.filter(b => b.icon == 'edit').length == 0 && this.auth.canEdit(this.user)) {
        this.rowActionButtons.push({ icon: 'edit', tooltip: 'Edit', eventEmitter: this.onEdit });
      } else if (!this.auth.canEdit(this.user)) {
        let eIndex = this.rowActionButtons.findIndex(b => b.icon == 'edit')
        if (eIndex > -1) {
          this.rowActionButtons.splice(eIndex, 1);
        }
      }

      if (this.topbarActionButton.filter(b => b.icon == 'add').length == 0 && this.auth.canEdit(this.user)) {
        this.topbarActionButton.push({ icon: 'add', tooltip: 'Add Category', eventEmitter: this.onAdd });
      } else if (!this.auth.canEdit(this.user)) {
        let aIndex = this.topbarActionButton.findIndex(b => b.icon == 'add')
        if (aIndex > -1) {
          this.topbarActionButton.splice(aIndex, 1);
        }
      }


      // if (this.rowActionButtons.filter(b => b.icon == 'clear').length == 0 && this.auth.canDelete(this.user))
      //   this.rowActionButtons.push({ icon: 'clear', tooltip: 'Remove', eventEmitter: this.onDelete });
      // else if (!this.auth.canDelete(this.user)) {
      //   let index = this.rowActionButtons.findIndex(b => b.icon == 'clear')
      //   if (index > -1) {
      //     this.rowActionButtons.splice(index, 1);
      //   }
      // }
    })


  }

  ngOnInit() {
    this.auth.user$.subscribe(user => this.user = user)


    this.approvedDataSource.sort = this.sort;

  }


  addCategory() {

    const dialogRef = this.dialog.open(CommonPopup, {
      disableClose: true,
      width: '500px',
      data: {
        siteId: this.siteId,
        formData: {
          title: "Add Category",
          inputFeilds: [
            {
              labelName: "Name",
              name: "name",
              required: false,
              type: "text",
              value: null,
              specialText: ""
            }
          ],
          buttons: [
            {
              name: "ADD",
              type: "submit",
              color: "primary",
              validate: true
            }
          ]
        }
      }
    });

    this.dialogSub = dialogRef.afterClosed().subscribe(async result => {



      if (result) {
        const newUserData = result.value;
        // Check if any data was entered
        if ((!newUserData.name)) {
          this.notifierService.showNotification("error", "Employee id or name needs to be entered!")
          return;
        } else {
          // this.productService.createCategory(newUserData);
        }
      }
    });

    // this.router.navigate(['system/new'],{relativeTo:this.route})

  }



  deleteUser(id: number) {
    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "DELETE",
          message: " Are you sure to continue? ",
          buttons: ['Cancel', 'Yes']
        }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(id)
        this.scheculedTaskService.deleteTask(id)
      }
    });

  }


  onBack() {
    this.router.navigate(['../'], { relativeTo: this.route })
  }

  showDetail(eventData) {
    let data = eventData
    data.siteId = this.siteId;

    // console.log("data", data)
    const dialogRef = this.dialog.open(TaskDetailPopup, {
      disableClose: true,
      width: '700px',
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');

    });
  }





  updateAgain() {

    console.log("buttong")
this.scheculedTaskService.getAllTasksData()

    // this.scheculedTaskService.getAllTasks().subscribe(doc => {
    //   for (let index = 0; index < doc.length; index++) {
    //     const element = doc[index];
    //     console.log(element)
    //     let unixTime = 0;
    //     let minute = 0
    //     let utc = 0;

    //     if (element['setMinutes']) {
    //       minute = element['setMinutes'];
    //       unixTime = moment().hour(Number(element['setHour']) - utc).minute(minute).unix();
    //     } else
    //       unixTime = moment().hour(Number(element['setHour']) - utc).minute(minute).unix();
    //     if (element['renewalMonthly'])
    //       unixTime = moment().endOf('month').hour(Number(element['setHour']) - utc).unix();
    //     // d.setMinutes(0);

    //     this.systemService.updateTask(element['dbid'], {
    //       status: 'scheduled',
    //       performAt: unixTime
    //     });
    //   }
    // })








  }


  ngOnDestroy(): void {
    if (this.paramsSub) this.paramsSub.unsubscribe();
    if (this.dialogSub) this.dialogSub.unsubscribe();
    this.onDeleteSubscription.unsubscribe();
    this.onAddSubscription.unsubscribe();
    // this.onEditSubscription.unsubscribe();
  }

}



